/**
 * マニフェスト 運搬終了報告 ダイアログ表示前バリデーション
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/report_confirmations/verifications`

const manifest_report_confirmation_verification = {
  namespaced: true,
  actions: {

    show ({ commit }, { params }) {
      const api_path = `${API_PATH}/report_items`;
      return new Promise((resolve) => {
        Vue.$http.post(api_path, params).then(data => {
          resolve(data.content)
        })
      })
    }
  },
}

export default manifest_report_confirmation_verification
